export default {
    type: 'toggle',
    format: {},
    default: {
        logic: 'match',
        value: 'yes'
    },
    setting: {
        logic: []
    },
    options: {
        yes: 'Yes',
        no: 'No'
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Has Play Location',
        category: ['User', 'Plays'],
        description: 'Whether play has a location or not.',
        summarise: {
            template: {
                yes: 'Play has a location',
                no: 'Play does not have a location'
            }
        }
    },
    rules: {
        linked: [],
        legacy: ['play.reports.locations']
    }
}